import React, { useEffect, useState } from "react";
import axios from "axios";
import 'quill/dist/quill.snow.css';
import { EXPRESS_BASE_URL } from "../../Helpers/apiConfig";

// Kayit sayfasindaki sozlesme linklerinin actigi, giris gerektirmeyen
// salt-okunur sayfa. Admin panelinde "Genel Ayarlar" altinda girilen ayni
// metni (GET /getmaintexts) gosterir; duzenleme yapilamaz. AuthLayout'un
// altina nested route olarak baglandigi icin login/register ile ayni
// navbar'i miras alir.
const PublicLegalTextPage = ({ field, title }) => {
    const [html, setHtml] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await axios.get(`${EXPRESS_BASE_URL}/getmaintexts`);
                const row = (res.data && res.data[0]) || {};
                setHtml(row[field] || "");
            } catch (err) {
                setHtml("");
            }
            setLoading(false);
        };
        fetchData();
    }, [field]);

    return (
        <div style={{ backgroundColor: "#f4f6f8", minHeight: "calc(100vh - 100px)" }} className="py-5">
            <div className="container">
                <h1 className="text-center mb-4" style={{ fontWeight: 700, color: "#222" }}>{title}</h1>
                {loading ? (
                    <p className="text-center">Yükleniyor...</p>
                ) : html ? (
                    <div
                        className="bg-white rounded-3 shadow-sm mx-auto p-4 p-md-5"
                        style={{ maxWidth: "900px" }}
                    >
                        <div
                            className="ql-editor"
                            style={{ fontSize: "16px", fontFamily: "calibri", color: "#333", lineHeight: "1.8", padding: 0 }}
                            dangerouslySetInnerHTML={{ __html: html }}
                        />
                    </div>
                ) : (
                    <p className="text-center">İçerik henüz eklenmemiş.</p>
                )}
            </div>
        </div>
    );
};

export default PublicLegalTextPage;
